import { FunctionTypes } from '../../../components/ContributorSection/helpers';
export var TabHeaders;
(function (TabHeaders) {
  TabHeaders["Website"] = "Website";
  TabHeaders["Book"] = "Book";
  TabHeaders["Magazine"] = "Magazine";
  TabHeaders["Newspaper"] = "Newspaper";
})(TabHeaders || (TabHeaders = {}));
export var INPRINT_PUB_INFO_SECTION_TITLE = 'In print publication info';
export var WEBSITE_PUBLICATION_INFO = 'Website publication info';
export var MAGAZINE_PUBLICATION_INFO = 'Magazine publication info';
export var NEWSPAPER_PUBLICATION_INFO = 'Newspaper publication info';
export var PREFIX_FOR_TEST_IDS = 'cartoon-form';
export var TypeOnlyOptions = [{
  key: 'cartoon',
  value: 'Cartoon'
}, {
  key: 'comic strip',
  value: 'Comic Strip'
}];
export var CartoonContributorFunctions = [FunctionTypes.AUTHOR, FunctionTypes.EDITOR, FunctionTypes.COMPILER, FunctionTypes.TRANSLATOR];
export var TestIds = {
  CARTOON_INPRINT_PUB_INFO_SECTION: "".concat(PREFIX_FOR_TEST_IDS, "-inprint-pub-info-sec-test-id"),
  CARTOON_WEBSITE_PUB_INFO_SECTION: "".concat(PREFIX_FOR_TEST_IDS, "-website-pub-info-sec-test-id"),
  CARTOON_MAGAZINE_PUB_INFO_SECTION: "".concat(PREFIX_FOR_TEST_IDS, "-magazine-pub-info-sec-test-id"),
  CARTOON_NEWSPAPER_PUB_INFO_SECTION: "".concat(PREFIX_FOR_TEST_IDS, "-newspaper-pub-info-sec-test-id")
};